import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { AnimatedFlyingText } from 'components'
import TasteProfileCarousel from '../TasteProfileCarousel'
import styles from './resultLoading.css'

const ResultLoading = (props) => (
  <div className={styles.wrapper}>
    <div className={styles.textContainer}>
      <h1 className={classnames(styles.header)}>
        <AnimatedFlyingText
          visible={!props.animationMinTimeCompleted}
          speed={2}
          inverted
        >
          {[
            'Één moment...',
            'We creëren',
            'jouw rode en witte'
          ]}
        </AnimatedFlyingText>
        <span
          className={classnames(styles.lastLine, {
            [styles.slideUpLastLine]: props.animationMinTimeCompleted
          })}
        >
          Smaakprofielen
        </span>
      </h1>
    </div>
    <TasteProfileCarousel {...props} />
  </div>
)

ResultLoading.defaultProps = {
  animationMinTimeCompleted: false
}

ResultLoading.propTypes = {
  animationMinTimeCompleted: PropTypes.bool
}

export default ResultLoading
